import { Link } from '@inertiajs/react';
import clsx from 'clsx';
import { LucideIcon } from 'lucide-react';
import React from 'react';

interface MenuItemProps {
    id: string;
    label: string;
    icon: LucideIcon;
    isActive: boolean;
    href: string;
    onClick: (id: string) => void;
    isCollapsed?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({
    id,
    label,
    icon: Icon,
    isActive,
    href,
    onClick,
    isCollapsed = false,
}) => {
    const isExternalLink =
        href.startsWith('http://') || href.startsWith('https://');
    const menuItemClassName = clsx(
        'group',
        isActive ? 'menu-item-active' : 'menu-item-inactive',
        isCollapsed && 'justify-center px-3'
    );

    const menuItemTitle = isCollapsed ? label : undefined;

    if (href === '#') {
        return (
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onClick(id);
                }}
                className={menuItemClassName}
                title={menuItemTitle}
                aria-label={label}
            >
                <Icon
                    size={20}
                    className={
                        isActive
                            ? 'text-white'
                            : 'text-neutral-400 group-hover:text-white'
                    }
                />
                {!isCollapsed && <span className="font-medium">{label}</span>}
            </a>
        );
    }

    if (isExternalLink) {
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => onClick(id)}
                className={menuItemClassName}
                title={menuItemTitle}
                aria-label={label}
            >
                <Icon
                    size={20}
                    className={
                        isActive
                            ? 'text-white'
                            : 'text-neutral-400 group-hover:text-white'
                    }
                />
                {!isCollapsed && <span className="font-medium">{label}</span>}
            </a>
        );
    }

    return (
        <Link
            href={href}
            onClick={() => onClick(id)}
            className={menuItemClassName}
            title={menuItemTitle}
            aria-label={label}
        >
            <Icon
                size={20}
                className={
                    isActive
                        ? 'text-white'
                        : 'text-neutral-400 group-hover:text-white'
                }
            />
            {!isCollapsed && <span className="font-medium">{label}</span>}
        </Link>
    );
};

export default MenuItem;
